import { makeStyles } from "@material-ui/core/styles"
//todo use  color: theme.palette.primary.main, on filter button
const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    backgroundColor: "#FFF",
  },
  tableContainer: {
    display: "flex",
    paddingRight: "20px",
    backgroundColor: "#FFF",
    padding: theme.spacing(1),
    alignContent: "flex-start",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      paddingRight: theme.spacing(1),
      alignContent: "center",
      flexDirection: "column",
    },
  },
  tabsContainer: {
    paddingTop: "20px",
    backgroundColor: "#FFF",
    flexGrow: 0,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      paddingTop: "5px",
    },
  },
  buttonWrapper: {
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "row",
      justifyContent: "space-between",
      padding: 0,
      margin: "5px 0",
      overflowY: "auto",
    },
  },
  button: {
    marginTop: theme.spacing(1),
    textTransform: "none",
    fontSize: "0.875rem",
    fontWeight: 600,
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      margin: "0 5px",
      minWidth: "110px",
    },
  },
  rightButton: {
    textTransform: "none",
    marginLeft: "10px",
  },
}))

export default useStyles
